import script from "./Form.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Form.vue?vue&type=script&setup=true&lang=js"

import "./Form.vue.scss?vue&type=style&index=0&id=cb080150&lang=scss&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Form.vue?vue&type=style&index=0&id=cb080150&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb080150"]])

export default __exports__